import Container from 'react-bootstrap/Container'
import React, { useEffect, useState } from 'react'
import './movies.css'
import English from './English'
import {
  initialmovieInputValue,
  intitalBooleanValueChangeDone,
} from '../Data/StaticPersonandMoviedata'
import SubmitCreateMovie from './SubmitCreateMovie'
import EnglishandTeluguFields from './EnglishandteField'
import ImportMovies from './Importmovie'
import { Col, Row } from 'react-bootstrap'
import RadioButtonmovieswebseries from './RadioButtonmovieswebseries'
import LoadingSpinner from './Loading'
import { useHistory } from 'react-router-dom'
import GalleryVideos from './GalleryVideos'
import GalleryImages from './GalleryImages'
import { DefinedPermissions } from '../Constants/Permissions'
import { Auth } from 'aws-amplify'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
// import ApproveMoviePerson from './ApproveMoviePerson'
import ApproveCreateMoviePerson from './ApproveCreateMoviePerson'
import GoatAndPopular from './GoatAndPopular'
import {
  ArticleValidation,
  checkArticleRating,
  // ReviewValidation,
  checkOTTStatus,
  checkOttAndUrl,
  checkOttFieldsDateExistsorNot,
  checkReviewValidationEn,
  checkReviewValidationTe,
  // checkReviewValidationEn,
  // checkReviewValidationTe,
  checkValidation,
  releaseDateValidation,
} from './MovieValidationFunctions'
export default function CreateMovie(props) {
  const { modeUrl } = props

  const [inputData, setInputData] = useState(initialmovieInputValue)
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const [afterClickingDisable, setafterClickingDisable] = useState(true)
  const [horizonataImage, setHoriZontalImage] = useState(false)
  const [movieData, setmoviedata] = useState({ items: [] })
  const [moviePublishingApproveal, setMoviePublishingApproval] = useState(false)
  const [modelPopUp, setModalPopUp] = useState(false)
  const episodesandRating =
    (inputData.contentType === 'movies' ? true : inputData.noOfEpisodes !== '') &&
    (inputData.imdb !== '' || inputData.MovieYouSayRating !== '')

  const updateInputData = (fieldname, fieldvalue) => {
    const data = { ...inputData }
    data[fieldname] = fieldvalue
    setInputData(data)
  }

  const [BooleanValueChangeDone, setBooleanValueChangeDone] = useState(
    intitalBooleanValueChangeDone,
  )

  const sendBooleanValueChangeDone = (field, data) => {
    const BooleanValueChangeDoneTemp = { ...BooleanValueChangeDone }
    BooleanValueChangeDoneTemp[field] = data
    setBooleanValueChangeDone(BooleanValueChangeDoneTemp)
  }

  const sendinputdata = data => {
    setInputData(data)
  }

  const clearAll = () => {
    setInputData(initialmovieInputValue)
    window.location.reload(false)
  }

  const handlecontentTypeChange = (field, data) => {
    const dataTemp = { ...inputData }
    dataTemp[field] = data
    setInputData(dataTemp)
  }

  // const releaseDateValidation = (status, releaseDate) => {
  //   if (status.includes('MovieReleaseDateRevealed')) {
  //       return releaseDate !== ''
  //   }

  //     return true
  // }

  const submitMovie = async () => {
    setafterClickingDisable(false)
    setIsLoading(true)

    const response = await SubmitCreateMovie(inputData, BooleanValueChangeDone)

    if (response.statusCode === 'A003') {
      const movieDataTemp = { ...movieData }
      movieDataTemp.PK = response.PK
      movieDataTemp.SK = response.SK
      setmoviedata(movieDataTemp)
      if (moviePublishingApproveal) {
        setIsLoading(false)
        setModalPopUp(true)
      } else {
        setTimeout(() => {
          history.push('/editmovie?' + encodeURI(response.PK))
          clearAll()
        }, 6000)
      }
    } else {
      setIsLoading(false)
    }
  }

  //   const CheckOttandUrl = data => data.every((e, index) => {
  //     if (inputData.ott[index].label) {
  //       if (e.link.length > 0) {
  //         return true
  //       }

  //         return false
  //     }

  // if (e.link.length > 0) {
  //       if (inputData.ott[index].label) {
  //         return true
  //       }

  //       return false
  //     }

  //       return true
  //       })

  // const checkOttFieldsExistsorNot = (checkOttFieldsExists, ottDates) => {
  //   if (checkOttFieldsExists) {
  //     if (ottDates.length > 0) {
  //       return true
  //     }

  //       const releaseDate = new Date(inputData.releaseDate).getFullYear()
  //       return releaseDate <= 2015 || inputData.ottDateUi
  //   }

  //     return true
  // }

  // const checkReviewValidationEn = inputData => (inputData.movieReviewArticleTitleEn && inputData.MovieYouSayReviewUrl) ||
  // (!inputData.movieReviewArticleTitleEn && !inputData.MovieYouSayReviewUrl)

  // const checkReviewValidationTe = inputData => (inputData.movieReviewArticleTitleTe && inputData.MovieYouSayReviewUrlTe) ||
  // (!inputData.movieReviewArticleTitleTe && !inputData.MovieYouSayReviewUrlTe)

  // const checkValidation = inputData => (inputData.movieName.length > 0 &&
  //   inputData.movieNamete.length > 0 &&
  //   inputData.language.length > 0 &&
  //   inputData.restrit !== '' &&
  //   inputData.poster.length > 0 &&
  //   inputData.Bio.length > 3 &&
  //   inputData.biote.length > 3 &&
  //   inputData.genRe.length >= 1 &&
  //   inputData.Moviecast.length >= 1 &&
  //   inputData.Moviedirector.length >= 1 &&
  //   inputData.MovieProducer.length >= 1)

  const updateButtonDisable = () => {
    // Extract ottDates from Movielinks
    const ottDates = inputData.Movielinks.filter(e => e.ottDate).map(e =>
      new Date(e.ottDate).getTime(),
    )

    // Check if ottLabel and ottLink are present based on ottStatus
    const hasOTTFields =
      inputData.Movielinks &&
      inputData.Movielinks.length > 0 &&
      inputData.Movielinks.some(
        (e, index) => inputData.ott[index] && inputData.ott[index].label !== '',
      )

    // const hasOTTLinks =
    //   inputData.Movielinks &&
    //   inputData.Movielinks.length > 0 &&
    //   inputData.Movielinks.some(e => e && e.link !== '')

    // Check if ottFieldsDate exists or not
    const hasOTTFieldsDate = checkOttFieldsDateExistsorNot(hasOTTFields, ottDates)

    // Check if both ott and url are available
    const hasOTTAndUrl = checkOttAndUrl(inputData, inputData.Movielinks)

    // Validate release date
    const releaseDateValid = releaseDateValidation(
      inputData.movieStatus,
      inputData.releaseDate,
      inputData,
    )

    // Validate other input data
    const isValid =
      checkValidation(inputData) &&
      releaseDateValid &&
      inputData.wikilink.length >= 4 &&
      inputData.restrit !== '' &&
      episodesandRating

    // // Determine ottStatus conditions
    // const ottStatus = inputData.OTTStatus
    // const ottStatusConditions =
    //   ottStatus ===
    //     'OTTProviderRevealedAndDateAnnounced' ||
    //   ottStatus ===
    //     'OTTProviderAndDateKnownAndLinkNotAvailable' ||
    //   ottStatus === 'OTTProviderDateAndLinkAvailable'

    // // Check ott fields based on ottStatus conditions
    // const ottFieldsCheck =
    //   ottStatusConditions &&
    //   ottStatus !== 'OTTProviderRevealedAndDateAnnounced'
    //     ? hasOTTFieldsDate && hasOTTAndUrl && hasOTTFields
    //     : true

    // Validate review for English
    // const reviewValidation = ReviewValidation(inputData.yousayArticleReviews)
    const reviewValidationEn = checkReviewValidationEn(inputData.yousayArticleReviews)
    const reviewValidationTe = checkReviewValidationTe(inputData.yousayArticleReviews)
    const articleReviewRatingCheck = checkArticleRating(inputData.yousayArticleReviews)
    const aricleValidation = ArticleValidation(
      reviewValidationEn,
      reviewValidationTe,
      articleReviewRatingCheck,
    )

    // Validate review for Telugu
    // const reviewValidationTe = checkReviewValidationTe(inputData)

    // Check if any conditions fail for disabling the button
    return !(
      (
        Object.values(BooleanValueChangeDone).some(e => e === true) &&
        isValid &&
        episodesandRating &&
        (inputData.OTTStatus === 'OTTProviderRevealedAndDateAnnounced' ||
        inputData.OTTStatus === 'OTTProviderAndDateKnownAndLinkNotAvailable' ||
        inputData.OTTStatus === 'OTTProviderDateAndLinkAvailable'
          ? hasOTTFieldsDate
          : true) &&
        (inputData.OTTStatus === 'OTTProviderDateAndLinkAvailable' ||
        inputData.OTTStatus === 'OTTProviderRevealedAndLinkAvailableAndDateNotKnown'
          ? hasOTTAndUrl
          : true) &&
        (checkOTTStatus(inputData) ? hasOTTFields : true) &&
        // ottFieldsCheck &&
        aricleValidation
      )
      // reviewValidationTe
    )
  }

  useEffect(() => {
    const getPermissions = async () => {
      const permissionInput = {
        mobileNumber: Auth.user.attributes.phone_number,
      }
      const userPermissions = await GetUserPermissions(permissionInput)
      const permissions = []
      const permissionsArr = []
      if (userPermissions && userPermissions.userRolesAndPermissions) {
        userPermissions.userRolesAndPermissions.map(item => {
          permissions.push(...item.permissions)
          return item
        })
        permissions.map(permission => {
          permissionsArr.push(permission.name)
          return permission
        })
      }

      const moviePublishingUserApprovePermission = permissionsArr.includes(
        DefinedPermissions.DisplayApproveMovieOption,
      )
      setMoviePublishingApproval(moviePublishingUserApprovePermission)
    }

    getPermissions()
  }, [])

  return (
    <div className='movie1' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'inherit' }}>
      {isLoading && <LoadingSpinner />}
      <Row>
        <Col md={6} xs={12}>
          <div style={{ width: '520px' }}>
            {modeUrl ? <></> : <div style={{ height: '50px' }}></div>}
            <RadioButtonmovieswebseries
              inputData={inputData}
              handlecontentTypeChange={handlecontentTypeChange}
            />
            <div
              className='movie1'
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'inherit',
                position: 'relative',
              }}
            >
              <div className='movie p-3'>
                <div className='createmovie'>
                  {inputData.contentType === 'movies' ? 'Create Movie' : 'Create Webseries'}
                </div>
                <form style={{ width: '100%' }}>
                  <Container>
                    <GoatAndPopular
                      inputData={inputData}
                      Popular={inputData.popularMovie}
                      sendInputData={sendinputdata}
                      sendBooleanValueChangeDone={sendBooleanValueChangeDone}
                      GOAT={inputData.GOAT}
                    />
                    <EnglishandTeluguFields
                      movieMode={'create'}
                      inputData={inputData}
                      movieData={movieData}
                      BooleanValueChangeDone={BooleanValueChangeDone}
                      sendBooleanValueChangeDone={sendBooleanValueChangeDone}
                      updateInputData={updateInputData}
                      sendinputdata={sendinputdata}
                      setIsLoading={setIsLoading}
                    />
                    <English
                      movieMode={'create'}
                      inputData={inputData}
                      movieData={movieData}
                      BooleanValueChangeDone={BooleanValueChangeDone}
                      sendBooleanValueChangeDone={sendBooleanValueChangeDone}
                      updateInputData={updateInputData}
                      sendinputdata={sendinputdata}
                    />
                    <GalleryImages
                      inputData={inputData}
                      GalleryImages={inputData.GalleryImages}
                      ImageType={'movie'}
                      sendinputdata={sendinputdata}
                      setHoriZontalImage={setHoriZontalImage}
                      horizonataImage={horizonataImage}
                      sendBooleanValueChangeDone={sendBooleanValueChangeDone}
                    />
                    <GalleryVideos
                      inputData={inputData}
                      GalleryVideos={inputData.GalleryVideos}
                      sendinputdata={sendinputdata}
                      sendBooleanValueChangeDone={sendBooleanValueChangeDone}
                    />
                    <br />
                  </Container>
                </form>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button
                    disabled={updateButtonDisable() && afterClickingDisable}
                    className='btn btn-primary'
                    onClick={() => submitMovie()}
                  >
                    {inputData.contentType === 'movies' ? 'Create Movie' : 'Create Webseries'}
                  </button>
                </div>
                <span>* mandatory to submit</span>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {!modeUrl && (
        <Col md={6} xs={12} className='urlcheck'>
          <ImportMovies
            editData={inputData}
            wikilink={inputData.wikilink}
            scrapeMovie={true}
            contentType={inputData.contentType}
            editMovieData={movieData}
            sendmovieData={setmoviedata}
            setIsLoading={setIsLoading}
            sendEditdata={sendinputdata}
            sendBooleanValueChangeDone={sendBooleanValueChangeDone}
          />
        </Col>
      )}
      {modelPopUp && moviePublishingApproveal && (
        <ApproveCreateMoviePerson
          loadPopup={modelPopUp}
          setLoadPopup={setModalPopUp}
          moviePerson={'movie'}
          movieData={movieData}
          sendTFIDBPN={inputData.sendTFIDBPN}
        />
      )}
    </div>
  )
}
